import React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { IconButton } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useTranslation } from "react-i18next";
import EyeIcon from "@icons/myicons/eye.svg?react";

export const ChartMenu = ({ onHide }: { onHide: () => void }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const { t } = useTranslation();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton onClick={handleClick} size="small" data-testid="chart-menu">
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu
        id="customized-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem
          data-testid="chart-menu-hide"
          onClick={() => {
            onHide();
          }}
        >
          <ListItemIcon>
            <EyeIcon />
          </ListItemIcon>
          <ListItemText primary={t("fundamentals.chartMenu.hide")} />
        </MenuItem>
      </Menu>
    </div>
  );
};
